<template>
    <CModal class="modal-chooseFile" title="Xuất báo cáo" :show.sync="isShowModal" :closeOnBackdrop="false"
      :size="'xl'">
      <div id="exportReportModal" class="custom-scroll">
        <CCard class="content-fade-in">
          <CCardBody>
            <CRow class="mb-3 search-panel">
              <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                <BaseSelect :options="typeSelect.options"
                        :data="typeSelect.data" ref="typeSelect"></BaseSelect>
              </CCol>
              <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                <div class="form-group">
                  <label style="color: white"></label>
                  <div>
                    <CButton style="float: right; margin-left: 5px" color="primary" v-c-tooltip.hover="'Xuất báo cáo'"
                      class="btn-action-primary" @click="exportReport()">
                      <i class="fa fa-download"></i>&nbsp; Xuất báo cáo
                    </CButton>
                  </div>
                </div>
              </CCol>
            </CRow>
            <CRow v-if="urlFile && urlFile != ''">
                <CCol xs="12" sm="12" md="12" lg="12" xl="12" style="min-height: 500px;">
                    <iframe :src="urlFile" style="width: 100%; height: 100%;"></iframe>
                </CCol>
            </CRow>
          </CCardBody>
        </CCard>
  
      </div>

      <template v-slot:footer>
            <CButton color="secondary" class="btn-action-primary" @click="isShowModal = false"> <i
                    class="fa fa-times"></i> Đóng </CButton>
            <!-- <button type="button" class="btn btn-primary" @click="submitData()">
                <i class="fa fa-check"></i> Chọn
            </button> -->
        </template>
    </CModal>
  </template>
  
  <script>
  import BaseTable from "@/views/base/BaseDataTable";
  import ModalConfirm from "@/views/base/BaseModalConfirm";
  import BaseInput from "@/views/base/BaseInput";
  import BaseSelect from "@/views/base/BaseSelect2";
  import BaseFormLoading from "@/views/base/BaseFormLoading";
  import BaseModal from "@/views/base/BaseModal";
  
  export default {
    name: "BaseExportModal",
    components: {
      BaseFormLoading,
      BaseTable,
      ModalConfirm,
      BaseInput,
      BaseSelect,
      BaseModal,
    },
    notifications: {
      showSuccessMsg: {
        type: "success",
        title: "Success",
      },
      showErrorMsg: {
        type: "error",
        title: "Error",
      },
      showWarningMsg: {
        type: "warn",
        title: "warn",
      },
    },
    props: ["id", "uri"],
    data() {
      let that = this;
      return {
        isShowModal: true,
        loading: {
          value: false,
        },
        urlFile: "",
        typeSelect: {
            options: {
                filter: false,
                label: "Loại tệp <span class='required'>*</span>",
            },
            data: {
                name: "type",
                items: [
                    { key: "pdf", value: "PDF" },
                    { key: "xlsx", value: "Excel" },
                    { key: "html", value: "Html" },
                    { key: "csv", value: "Csv" },
                ],
                model: "pdf"
            }
        },
      };
    },
    methods: {
        exportReport() {
            let that = this;
            this.$helper.loadDataSource({
                loading: that.loading,
                url: that.uri,
                isJsonContentType: false,
                dataSubmit: function () {
                    return { id: that.id, type: that.typeSelect.data.model }
                },
                successCallback: function (response) {
                    that.urlFile = response.data.data;
                    that.loading.value = false;
                },
                errorCallback: function (error) {
                    that.$helper.handleError(that.$router, error);
                    that.loading.value = false;
                }
            });
        }
    },
    created: function () {
    },
    mounted() {
      // this.loadData();
    },
    watch: {
      isShowModal: function (value) {
        if (!value) {
          this.$emit("close-modal", false);
        }
      },
    },
    computed: {
    },
  };
  </script>
